import { getIncidentTypeIdColor, getIncidentTypeIdColors } from '@/utils/getIncidentTypeColor';

const COLORS = getIncidentTypeIdColors();

export const getIncidentTagColor = (tagIdx: number) => {
  // Shift +2 position
  const tagNum = (tagIdx + 2) % COLORS.length;
  return getIncidentTypeIdColor(String(tagNum));
};
